import {
    SET_USERS_BY_SEARCH_TEXT,
    SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER,
    SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST
} from "./UserBySearchTextType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_USERS_BY_SEARCH_TEXT:
            return {
                ...state,
                usersBySearchText: action.usersBySearchText,
            };
        case SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER:
            return {
                ...state,
                isEmployeeAddedToCostCenter: action.flag,
            };
        case SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST:
            return {
                ...state,
                employeesWithHomeCostCenterList: action.response,
            };
        default:
            return state;
    }
}

export default reducers